/* eslint react/no-array-index-key: 0 */

import React from "react";
import PropTypes from "prop-types";
import OkCheckbox from "shared/components/oknf/OkCheckbox";
import PickManyButtons from "shared/components/PickManyButtons";
import classnames from "classnames";

const AcceptedAnswers = ({
	answers,
	currentAcceptedAnswers,
	onChangeAcceptedAnswers,
	disabled,
}) => {
	return (
		<PickManyButtons
			choices={answers.map((answer, i) => {
				return ({
					key: i,
					name: (
						<div
							className={classnames({
								"questionspage-multipartquestion-acceptableanswers-answer": true,
								[`questionspage-multipartquestion-acceptableanswers-answer-${i}`]: true,
							})}
							onChange={(ev) => {
								ev.preventDefault();
								ev.stopPropagation();
								onChangeAcceptedAnswers(i);
							}}
						>
							<div
								className="questionspage-multipartquestion-acceptableanswers-answer-label"
							>
								{answer}
							</div>
							<div
								className="questionspage-multipartquestion-acceptableanswers-
									answer-checkboxcontainer"
							>
								<OkCheckbox
									value={i}
									checked={currentAcceptedAnswers.indexOf(i) !== -1}
									readOnly
								/>
							</div>
						</div>
					),
					value: i,
				});
			})}
			values={currentAcceptedAnswers}
			onChange={(i) => onChangeAcceptedAnswers(i)}
			classRoot="questionspage-multipartquestion-acceptableanswers"
			disabled={disabled}
		/>
	);
};

AcceptedAnswers.propTypes = {
	answers: PropTypes.arrayOf(PropTypes.string).isRequired,
	currentAcceptedAnswers: PropTypes.arrayOf(PropTypes.number).isRequired,
	onChangeAcceptedAnswers: PropTypes.func.isRequired,
	disabled: PropTypes.bool.isRequired
};

export default AcceptedAnswers;



// WEBPACK FOOTER //
// ./src/apps/questions/components/AcceptedAnswers.jsx